<template lang="html">
  <div class="">
    <div class="info_startup">
      <div class="info_startup_1">
            <span class="info_name">{{label}}</span>
      </div>
      <div class="info_startup_2">
        <ul class="startup_founders">
          <!-- <li v-for="(founder ,f) in founders" :key="f" class="founder">
             {{founder.name}}, {{founder.poste}} <a :href="'https://'+founder.linkedin_profile" target="_blank" class="picto_link_linkedin"><img :src="require('@/assets/linkedin.svg')" alt=""/></a></li> -->

            <FounderLine v-for="(founder ,f) in founders" :key="f" :founder='founder'/>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import FounderLine from '@/components/Founder.vue'
export default {
  name : "StartupInfoLine",
  props: ["founders","label"],
  components: {
    FounderLine
  }
}
</script>

<style lang="css" scoped>

.info_startup{
  display:flex;
gap: 10px;
border-bottom: 1px solid #DDD;
padding-bottom: 10px;
padding-top: 10px;
}


.info_startup_1{
  width: 33%;
}
.info_startup_2{
  width: 66%;
    display:block;
}


@media screen and (max-width: 690px){
  .info_startup{
    flex-direction: column;
  }
  .info_startup_1,
  .info_startup_2{
    width:100%;
      display:block;
  }
}
.info_startup_1 .info_name{
font-size: 12px;
line-height: 15px;
color: #3783C5;
text-transform: uppercase;
font-weight: 700;
}
.info_startup_2 .info_value{
  font-size:16px;
  line-height: 22px;
}

.startup_founders{
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0px;
}
.founder{
  font-size: 16px;
  line-height: 28px;
  margin-left:0px;
  padding-left:0px;
}
.founder .picto_link_linkedin{
  margin-left:20px;
}
.info_value{
white-space: pre-wrap
}
</style>
